(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["console-telemetry-client"] = factory();
	else
		root["console-telemetry-client"] = factory();
})(self, () => {
return 